module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col page-element"
  }, [(_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('page-title', [_c('h3', [_vm._v("Lista faktur")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "td-no_link"
    }, [_vm._v("\n                    " + _vm._s(item.agreement.fullNumber) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v("\n                    " + _vm._s(item['number']) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("date")(item['createDate'])) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("date")(item['paymentDate'])) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v("\n                    " + _vm._s(item['amount']) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v("\n                    " + _vm._s(item['leftToPaid']) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [(item['paid']) ? _c('span', {
      staticClass: "element_status closed"
    }, [_vm._v("Zapłacona")]) : _vm._e(), _vm._v(" "), (!item['paid'] && !item['deducted']) ? _c('span', {
      staticClass: "element_status open"
    }, [_vm._v("Niezapłacona")]) : _vm._e(), _vm._v(" "), (item['deducted']) ? _c('span', {
      staticClass: "element_status deducted"
    }, [_vm._v("Potrącona")]) : _vm._e(), _vm._v(" "), (item['returned']) ? _c('span', {
      staticClass: "element_status returned"
    }, [_vm._v("Zwrócona")]) : _vm._e()])])
  }), 0)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Umowa")]), _vm._v(" "), _c('th', [_vm._v("Numer")]), _vm._v(" "), _c('th', [_vm._v("Data wystawienia")]), _vm._v(" "), _c('th', [_vm._v("Termin płatności")]), _vm._v(" "), _c('th', [_vm._v("Kwota")]), _vm._v(" "), _c('th', [_vm._v("Do zapłaty")]), _vm._v(" "), _c('th', [_vm._v("Status")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b79a5dd8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/debtor/InvoiceList.vue
// module id = 841
// module chunks = 0